import { useNavigate, useLocation } from 'react-router-dom';

export default function GanaderiaLayout({ children }) {
  const navigate = useNavigate();
  const location = useLocation();

  const tabs = [
    { name: 'Dashboard', path: '/ganaderia' },
    { name: 'Registro', path: '/ganaderia/registro' },
    { name: 'Peso', path: '/ganaderia/peso' },
    { name: 'Salud', path: '/ganaderia/salud' },
    { name: 'Reproducción', path: '/ganaderia/reproduccion' },
    { name: 'Inventario', path: '/ganaderia/inventario' },
  ];

  return (
    <div>
      {/* Sub-tabs for Ganadería - Responsive con scroll horizontal automático */}
      <div className="bg-gray-100 dark:bg-gray-800 border-b border-gray-200 dark:border-gray-700">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <nav className="mobile-tab-scroll -mx-4 sm:-mx-6 lg:-mx-8 px-4 sm:px-6 lg:px-8">
            <div className="flex gap-1 sm:gap-4 min-w-max">
              {tabs.map((tab) => {
                const isActive = location.pathname === tab.path;
                return (
                  <button
                    key={tab.path}
                    onClick={() => navigate(tab.path)}
                    className={`
                      px-3 sm:px-4 py-3 text-xs sm:text-sm font-medium transition-colors whitespace-nowrap shrink-0
                      ${isActive
                        ? 'text-rose-600 border-b-2 border-rose-600'
                        : 'text-gray-600 dark:text-gray-300 hover:text-gray-900 dark:hover:text-white border-b-2 border-transparent'
                      }
                    `}
                    data-testid={`ganaderia-tab-${tab.path.split('/').pop() || 'dashboard'}`}
                  >
                    {tab.name}
                  </button>
                );
              })}
            </div>
          </nav>
        </div>
      </div>

      {/* Content */}
      <div className="dark:text-white">
        {children}
      </div>
    </div>
  );
}
